/**
 * Page Sidebar Navigation
 * Handles submenu toggle and layout toggle functionality
 */
(function() {
    'use strict';

    // Layout toggle functionality
    function initLayoutToggle() {
        var containers = document.querySelectorAll('.page-with-sidebar');
        
        containers.forEach(function(container) {
            var collapseBtn = container.querySelector('.sidebar-collapse-btn');
            var expandBtn = container.querySelector('.sidebar-expand-btn');
            
            if (collapseBtn) {
                collapseBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    container.classList.add('page-with-sidebar--collapsed');
                    try {
                        localStorage.setItem('sidebar-collapsed', '1');
                    } catch (err) {}
                });
            }
            
            if (expandBtn) {
                expandBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    container.classList.remove('page-with-sidebar--collapsed');
                    try {
                        localStorage.setItem('sidebar-collapsed', '0');
                    } catch (err) {}
                });
            }
        });

        // Restore preference from localStorage
        try {
            var savedState = localStorage.getItem('sidebar-collapsed');
            if (savedState === '1') {
                containers.forEach(function(container) {
                    container.classList.add('page-with-sidebar--collapsed');
                });
            }
        } catch (e) {}
    }

    function initSidebarNav() {
        var sidebars = document.querySelectorAll('.sidebar-nav');
        
        // Initialize layout toggle
        initLayoutToggle();
        
        if (!sidebars.length) return;

        sidebars.forEach(function(sidebar) {
            // Submenu toggles - use event delegation
            sidebar.addEventListener('click', function(e) {
                var toggleBtn = e.target.closest('.sidebar-nav__toggle');
                if (!toggleBtn) return;
                
                e.preventDefault();
                e.stopPropagation();
                
                var isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
                var item = toggleBtn.closest('.sidebar-nav__item');
                
                if (!item) return;
                
                // Find the direct child submenu
                var submenu = item.querySelector(':scope > .sidebar-nav__submenu');
                
                // Fallback for browsers that don't support :scope
                if (!submenu) {
                    var children = item.children;
                    for (var i = 0; i < children.length; i++) {
                        if (children[i].classList.contains('sidebar-nav__submenu')) {
                            submenu = children[i];
                            break;
                        }
                    }
                }
                
                // Toggle state
                var newState = !isExpanded;
                toggleBtn.setAttribute('aria-expanded', String(newState));
                
                if (newState) {
                    toggleBtn.classList.add('sidebar-nav__toggle--open');
                    if (submenu) submenu.classList.add('sidebar-nav__submenu--open');
                } else {
                    toggleBtn.classList.remove('sidebar-nav__toggle--open');
                    if (submenu) submenu.classList.remove('sidebar-nav__submenu--open');
                }
            });

            // Mobile toggle
            var mobileToggle = sidebar.querySelector('.sidebar-nav__mobile-toggle');
            var navList = sidebar.querySelector('.sidebar-nav__list');
            
            if (mobileToggle && navList) {
                mobileToggle.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    var isExpanded = this.getAttribute('aria-expanded') === 'true';
                    var newState = !isExpanded;
                    
                    this.setAttribute('aria-expanded', String(newState));
                    
                    if (newState) {
                        this.classList.add('sidebar-nav__mobile-toggle--open');
                        navList.classList.add('sidebar-nav__list--open');
                    } else {
                        this.classList.remove('sidebar-nav__mobile-toggle--open');
                        navList.classList.remove('sidebar-nav__list--open');
                    }
                });

                // Check viewport and adjust
                function checkViewport() {
                    if (window.innerWidth > 768) {
                        navList.classList.add('sidebar-nav__list--open');
                        mobileToggle.setAttribute('aria-expanded', 'true');
                        mobileToggle.classList.add('sidebar-nav__mobile-toggle--open');
                    }
                }
                
                checkViewport();
                window.addEventListener('resize', checkViewport);
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSidebarNav);
    } else {
        initSidebarNav();
    }
})();

